import gql from "graphql-tag"

export const USER_INSTALLATIONS_QUERY = gql`
  query userInstalls {
    installationsForUser {
      id
      name
      targetType
      repositorySelection
      settingsUrl
    }
  }
`
